<template>
    <!-- 主容器 -->
    <div class="yx-div">
        <!-- 工具栏 -->
        <div class="yx-div-top">
            <div class="yx-flex-h-between">
                <div class="yx-flex-h-start2">
                    <div>
                        检索：
                        <el-input placeholder="查询内容" v-model="searchVal.keyword" clearable class="input-with-select" style="width: 400px">
                            <el-select v-model="searchVal.keywordMethod" slot="prepend" placeholder="选择关键字" class="el-select-with-input">
                                <el-option
                                        v-for="item in keywordList"
                                        :key="item.id"
                                        :label="item.name"
                                        :value="item.id">
                                </el-option>
                            </el-select>
                        </el-input>
                    </div>
                    <el-tooltip content="清空查询条件"><i class="el-icon-circle-close cls-refresh" @click="searchReset"/></el-tooltip>
                </div>
                <div>
                    <el-button icon="el-icon-search" type="primary" @click="searchDo">查询</el-button>
                    <el-button type="warning" @click="showFV = !showFV">
                        <i :class="showFV?'fa fa-angle-double-up':'fa fa-angle-double-down'" aria-hidden="true"></i>
                    </el-button>
                </div>
            </div>
            <div v-show="showFV" class="yx-flex-h-start" style="margin-top: 15px;">

            </div>
            <div class="yx-flex-h-start" style="margin-top: 15px;">
                <el-button type="danger" icon="el-icon-plus" @click="viewAdd">新增客户经理</el-button>

                <el-dropdown trigger="click" @command="changeSalStatus" style="margin-left: 15px;">
                    <el-button type="danger" icon="el-icon-setting" @click="" :disabled="disableBtn">
                        账号关停 <i class="el-icon-arrow-down el-icon--right" />
                    </el-button>
                    <el-dropdown-menu slot="dropdown">
                        <el-dropdown-item v-for="(item,index) in SalUserAccStatuses" :key=index :command="item.id">{{item.name}}</el-dropdown-item>
                    </el-dropdown-menu>
                </el-dropdown>

            </div>
        </div>


        <!-- 数据栏 -->
        <div class="yx-div-center">
            <!-- 数据表 -->
            <el-table
                    :data="sals"
                    border
                    :header-cell-style="{background:'#fafafa'}"
                    @selection-change="handleSelectionChange"
                    v-loading="loading"
                    height="100%"
                    style="width: 100%">
                <el-table-column type="selection" align="center"> </el-table-column>
                <el-table-column prop="id" label="ID" width="200"></el-table-column>
                <el-table-column prop="userCode" label="账号" width="150"></el-table-column>
                <el-table-column prop="name" label="姓名" width="150" show-overflow-tooltip></el-table-column>
                <el-table-column prop="phone" label="电话" width="150"></el-table-column>
                <!--
                <el-table-column prop="agentId" label="服务商ID" width="100"></el-table-column>
                -->
                <el-table-column prop="sysLoginInfo.agentName" label="服务商" width="200" show-overflow-tooltip></el-table-column>
                <el-table-column
                        align="center"
                        width="100"
                        label="账号状态">
                    <template slot-scope="scope">
                        <el-tag type="success" v-if="scope.row.sysLoginInfo.enabled" color="#FFFFFF">正常</el-tag>
                        <el-tag type="info" v-else color="#FFFFFF">停用</el-tag>
                    </template>
                </el-table-column>
                <el-table-column fixed="right" label="操作" width="120" align="center">
                    <template slot-scope="scope">
                        <!--
                        <el-button type="info" plain size="mini" style="padding: 5px" @click="viewEdit(scope.row)">编辑</el-button>
                        -->
                        <el-button type="primary" plain size="mini" style="padding: 5px" @click="viewDetail(scope.row)">详情</el-button>
                    </template>
                </el-table-column>
            </el-table>
        </div>

        <!-- 分页栏 -->
        <div class="yx-flex-h-between">
            <el-pagination
                    background
                    :current-page.sync="page"
                    @current-change="currentChange"
                    @size-change="sizeChange"
                    layout="sizes, prev, pager, next, jumper, ->, total, slot"
                    :total="total">
            </el-pagination>
        </div>

        <SalBaseDlg :key="keyCompDlg" v-bind:inOptType="dlgModel" v-bind:inSalInfo="salInfo" v-bind:outDlgClosed.sync="dlgClosed"/>

    </div>

</template>

<script>

    import {
        URL_AGENT_FROMS
    } from "../../utils/cons";
    import {deepClone} from '../../utils/datatool'
    import AgentDetailDiv from "../../components/agent/AgentDetailDiv";
    import SalBaseDlg from "../../components/sal/SalBaseDlg";

    export default {
        name: "SalInfo",
        components: {SalBaseDlg, AgentDetailDiv},
        data() {
            return {
                drawer: false,
                disableBtn: true,
                dlgClosed: false,
                dlgModel: '',
                keyCompDlg: null,
                titleDlg: '',
                showFV: false,
                loading: false,
                total: 0,
                page: 1,
                size: 10,
                sals: [],
                SalUserAccStatuses:[{"id":0,"name":'确定'}],

                salInfo: {
                    id: null,
                    userCode: null,
                    name: null,
                    phone: null,
                    agentId: null,
                    sysLoginInfo: null,
                    userProductList: []
                },
                keywordList: [
                    {id:"name",name:"客户经理姓名"}
                    ],
                multipleSelection: [],
                searchVal: {
                    keywordMethod: '',
                    keyword: '',
                }
            }
        },
        watch: {
            dlgClosed: {
                handler: function (val) {
                    if (this.dlgClosed === true) {
                        this.initSals();
                    }
                }
            },
        },
        mounted() {
            this.initSals();
            },
        methods: {
            viewAdd() {
                this.dlgModel = 'INS';
                this.keyCompDlg = Date.now();
                this.dlgClosed = false;
            },
            viewEdit(data) {
                this.dlgModel = 'UPD';
                this.salInfo = deepClone(data);
                this.keyCompDlg = Date.now();
                this.dlgClosed = false;
            },
            viewDetail(data) {
                this.dlgModel = 'VIEW';
                this.salInfo = deepClone(data);
                this.keyCompDlg = Date.now();
                this.dlgClosed = false;

                // Object.assign(this.salInfo, data);
                // this.drawer = true;
            },
            changeSalStatus(command) {
                let ids = [];
                this.multipleSelection.forEach(item => { ids.push(item.sysLoginInfo.id); });


                this.putRequest("/mch/updateSalAccStat" + "?statusId=" + command + "&ids=" + ids).then(resp => {
                    if (resp) {
                        this.initSals();
                    }
                });

            },
            searchReset() {
                this.searchVal = {};
            },
            searchDo() {
                this.page = 1;
                this.initSals();
            },
            handleSelectionChange(val) {
                this.multipleSelection = val;
                if(this.multipleSelection.length>0) {
                    this.disableBtn = false;
                }
                else {
                    this.disableBtn = true;
                }
            },
            initSals() {
                this.loading = true;
                let url = '/sal/salInfo?page=' + this.page + '&size=' + this.size;


                if (this.searchVal.keywordMethod && this.searchVal.keyword) {
                    url += '&'+this.searchVal.keywordMethod+'=' + this.searchVal.keyword;
                }

                this.getRequest(url).then(resp => {
                    this.loading = false;
                    if (resp) {
                        this.sals = resp.data;
                        this.total = resp.total;
                    }
                })
            },
            sizeChange(currentSize) {
                this.size = currentSize;
                this.initSals();
            },
            currentChange(currentPage) {
                this.page = currentPage;
                this.initSals();
            },
            exportData() {
            }
        }

    }
</script>

<style scoped>
</style>
